import { useEffect } from "react";

import { Modal } from "antd-v4";

export default function CustomModal({
  title,
  message,
  visible,
  icon,
  hide,
  timetohide,
}) {
  useEffect(() => {
    if (visible) {
      setTimeout(() => hide(), timetohide); // automatic hide after X seconds
    }
  }, [visible]);

  return (
    <Modal
      title={null}
      open={visible}
      onOk={hide}
      onCancel={hide}
      footer={null}
      closable={false}
      centered
    >
      <div className="hp-text-center">
        <div className="hp-mb-8">
          {icon}
        </div>

        <span className="h1 hp-d-block hp-mb-8">{title}</span>

        <p className="hp-mb-0 hp-p2-body hp-font-weight-500 hp-text-color-black-80">
          {message}
        </p>
      </div>
    </Modal>
  );
}
